export function PublicMarquee() {
  const items: { text: string; color: string }[] = [
    { text: "Unabhängige Analyse ohne Verkaufsdruck", color: "var(--leaf-deep)" },
    { text: "Förderungen, Kosten & Wirtschaftlichkeit im Blick", color: "var(--leaf)" },
    { text: "Fundierte Entscheidungsgrundlage für Ihr Projekt", color: "var(--gold)" },
    { text: "100 % Datenschutz Ihrer Angaben", color: "var(--leaf-deep)" },
    { text: "100 % kostenlos & unverbindlich", color: "var(--leaf)" },
    { text: "Neutrale Analyse Ihrer Angebote", color: "var(--gold)" },
    { text: "Fördermittel optimal nutzen", color: "var(--leaf-deep)" },
    { text: "Steuerliche Potenziale erkennen", color: "var(--leaf)" },
    { text: "PV · Speicher · Wärmepumpe", color: "var(--gold)" },
    { text: "Herstellerunabhängig & transparent", color: "var(--leaf-deep)" },
  ];

  return (
    <div className="relative overflow-hidden border-y border-[var(--rule)] py-2.5" style={{ backgroundColor: "#d1d6e0" }}>
      <style>{`@keyframes ep-marquee { from { transform: translateX(0); } to { transform: translateX(-50%); } }`}</style>
      <div
        className="flex whitespace-nowrap text-sm md:text-base font-display font-semibold"
        style={{ animation: "ep-marquee 60s linear infinite", width: "max-content" }}
      >
        {Array.from({ length: 2 }).map((_, dup) => (
          <div key={dup} className="flex gap-12 pr-12 items-center">
            {items.map((it, i) => (
              <span key={i} className="flex items-center gap-12">
                <span style={{ color: it.color }}>{it.text}</span>
                <span style={{ color: it.color }}>●</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
